import React from 'react'
import Productpage from '../components/Productpage';

import Footer from '../components/footer';

export default function Products() {
  return (
    <>
    
    <div>
      <div className='App other-page-top'>
        <div className="BreakPointContainer AppContent">
          <div className="layout ProductList align-start">
           
            <Productpage/>
          </div>
        </div>
      </div>
    </div>
    <Footer />
    </>
  )
}
